'use strict';

/**
 * @typedef {Object} USER_PRIORITY
 * @property {Number} UN_PINNED
 * @property {Number} NONE
 * @property {Number} AUTO_PINNED
 * @property {Number} PINNED
 */

/** @type {USER_PRIORITY} */
export const USER_PRIORITY = {};

Object.defineProperties(USER_PRIORITY, {
  /** @deprecated */
  UN_PINNED: {enumerable: true, value: -1},
  NONE: {enumerable: true, value: 0},
  AUTO_PINNED: {enumerable: true, value: 1},
  PINNED: {enumerable: true, value: 2},
});

export function getToggledPriority(priority) {
  if (priority === USER_PRIORITY.AUTO_PINNED) {
    return USER_PRIORITY.PINNED;
  } else {
    return USER_PRIORITY.AUTO_PINNED;
  }
}



// WEBPACK FOOTER //
// ./src/js/priorities/enums/USER_PRIORITIES.js